import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useLabelsAPIClient = () => {
  const { set, remove, update } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const addNewLabel = useCallback(
    async (label) => {
      // Support both string (legacy) and object format
      const labelData = typeof label === "string" ? { name: label } : label;
      return await withNetworkErrorHandling(() =>
        set(`users/${activeUser.userId}/labels`, labelData),
      );
    },
    [activeUser, set],
  );

  const removeLabel = useCallback(
    async (labelId) => {
      return await withNetworkErrorHandling(() =>
        remove(`users/${activeUser.userId}/labels/${labelId}`),
      );
    },
    [activeUser, remove],
  );

  const updateLabel = useCallback(
    async (labelId, updates) => {
      return await withNetworkErrorHandling(() =>
        update(`users/${activeUser.userId}/labels/${labelId}`, updates),
      );
    },
    [activeUser, update],
  );

  return { addNewLabel, removeLabel, updateLabel };
};

export default useLabelsAPIClient;
